import React, { useState, useEffect, useCallback } from "react";
import {
  Box,
  Typography,
  Paper,
  Button,
  MenuItem,
  Select,
} from "@mui/material";
import { useLazyGetLogsQuery } from "../../Service/admin";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker as MuiDatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import BOPPList from "../BOPPList/BOPPList";

const LINE_TYPES = {
  LINE1: "Line 1",
  LINE2: "Line 2",
  LINE3: "Line 3",
  LINE4: "Line 4",
  LINE5: "Line 5",
  LINE6: "Line 6",
};

const Dashboard = () => {
  const todayDate = dayjs();
  const [toDate, setToDate] = useState(todayDate);
  const [logsList, setLogsList] = useState([]);
  const [fromDate, setFromDate] = useState(todayDate.subtract(7, "day"));
  const [currentPage, setCurrentPage] = useState(1);
  const [lineType, setLineType] = useState("");

  const [getLogs] = useLazyGetLogsQuery();

  const handleLogin = useCallback(() => {
    const fetchData = async () => {
      if (fromDate && toDate) {
        const response = await getLogs({
          from: formatDate(fromDate),
          to: formatDate(toDate),
          pageNo: currentPage,
          limit: 10,
          ...(lineType !== "" && { lineType: LINE_TYPES[lineType] }),
        });
        if (!response?.error) {
          setLogsList(response?.data?.logsDetailsInfo || []);
        }
      }
    };
    fetchData();
  }, [fromDate, toDate, currentPage, getLogs, lineType]);

  useEffect(() => {
    handleLogin();
  }, [fromDate, handleLogin, toDate]);

  const formatDate = (date) => date?.format("MM/DD/YYYY");

  const handleDateChange = (setter) => (newValue) => {
    if (newValue && newValue.isValid()) {
      setter(newValue);
    }
  };

  return (
    <Box sx={{ padding: 2 }}>
      <Typography variant="h5" fontWeight={600}>
        BOPP Check List
      </Typography>
      <Paper sx={{ marginTop: 3, padding: 2, borderRadius: 2, boxShadow: 3 }}>
        <Typography variant="body1" sx={{ marginTop: 2, fontWeight: "bold" }}>
          Today's Date: {formatDate(dayjs())}
        </Typography>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 2,
              marginTop: 4,
            }}
          >
            <MuiDatePicker
              label="From"
              inputFormat="MM/dd/yyyy"
              value={fromDate}
              maxDate={toDate}
              onChange={handleDateChange(setFromDate)}
              renderInput={(params) => <input {...params} />}
            />
            <MuiDatePicker
              label="To"
              inputFormat="MM/dd/yyyy"
              value={toDate}
              minDate={fromDate}
              maxDate={todayDate}
              onChange={handleDateChange(setToDate)}
              renderInput={(params) => <input {...params} />}
            />
            <Select
              sx={{ minWidth: 200, maxWidth: 300 }}
              value={lineType}
              displayEmpty
              onChange={(e) => setLineType(e.target.value)}
              renderValue={(selected) =>
                selected ? LINE_TYPES[selected] : "All Lines"
              }
            >
              <MenuItem value="">
                <em>All Lines</em>
              </MenuItem>
              {Object.keys(LINE_TYPES).map((item) => (
                <MenuItem value={item} key={item}>
                  {LINE_TYPES[item]}
                </MenuItem>
              ))}
            </Select>
            <Button size="medium" variant="contained" onClick={handleLogin}>
              Submit
            </Button>
          </Box>
        </LocalizationProvider>
      </Paper>
      <Paper sx={{ marginTop: 3, padding: 2, borderRadius: 2, boxShadow: 3 }}>
        <BOPPList
          logsList={logsList}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
        />
      </Paper>
    </Box>
  );
};

export default Dashboard;
